import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeductibleRequestStoreService  {

  constructor() { }

   private storedRequest: (() => Observable<any>) | null = null;

  setRequest(fn: () => Observable<any>) {
    this.storedRequest = fn;
  }

  getRequest(): (() => Observable<any>) | null {
    return this.storedRequest;
  }
}
